import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { Card } from 'react-bootstrap';
export var AppAccordion = forwardRef(function (_a, ref) {
    var className = _a.className, style = _a.style, isHidden = _a.isHidden, item = _a.item;
    var _b = useState(isHidden === undefined ? true : isHidden), hidden = _b[0], setHidden = _b[1];
    var _c = useState(''), transitioningClass = _c[0], setTransitioningClass = _c[1];
    useImperativeHandle(ref, function () { return ({
        toggle: function () {
            handleClick();
        },
        open: function () {
            handleOpen();
        },
        close: function () {
            handleClose();
        }
    }); });
    var content = useRef(null);
    var handleClick = function () {
        setTransitioningClass('overflow-hidden');
        setHidden(!hidden);
    };
    var handleOpen = function () {
        setTransitioningClass('overflow-hidden');
        setHidden(false);
    };
    var handleClose = function () {
        setTransitioningClass('overflow-hidden');
        setHidden(true);
    };
    var handleTransitionEnd = function () {
        setTransitioningClass('');
    };
    var _d = useState('auto'), height = _d[0], setHeight = _d[1];
    var onWindowResize = function () {
        setHeight(content.current.scrollHeight);
    };
    useEffect(function () {
        setHeight(content.current.scrollHeight);
        window.addEventListener('resize', onWindowResize);
        return function () { return window.removeEventListener('resize', onWindowResize); };
    }, []);
    useEffect(function () {
        setHeight(content.current.scrollHeight);
    });
    var headerStyle = hidden ? { color: '#8dabc4', border: 'none', fontWeight: 500 } : { color: '#8dabc4', fontWeight: 500 };
    var iconClass = hidden ? 'icon' : 'icon icon-rotate';
    var hiddenClass = hidden ? 'accordion-hidden' : '';
    return (React.createElement(Card, { className: "app-accordion ".concat(className, " ").concat(hiddenClass), style: style },
        React.createElement(Card.Header, { className: 'accordion-header d-flex justify-content-between', onClick: handleClick, style: headerStyle },
            React.createElement("span", null, item.title),
            React.createElement(FontAwesomeIcon, { icon: faAngleRight, className: iconClass })),
        React.createElement("div", { onTransitionEnd: handleTransitionEnd, className: "accordion ".concat(transitioningClass, " ").concat(hidden ? 'overflow-hidden' : ''), style: { height: hidden ? 0 : height } },
            React.createElement(Card.Body, { ref: content }, item.item))));
});
//# sourceMappingURL=app-accordion.js.map